<div class="d-flex full-height">
  <div class="w-75 m-auto">
    <div>
      <div class="mb-4">
        <a
          id="btn_back_home"
          routerLink="/"
          class="link-underline link-underline-opacity-0 align-items-center d-flex gap-1"
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_2703_52457)">
                <path
                  d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.56031L11.0306 18.2194C11.1003 18.289 11.1556 18.3718 11.1933 18.4628C11.231 18.5539 11.2504 18.6514 11.2504 18.75C11.2504 18.8485 11.231 18.9461 11.1933 19.0372C11.1556 19.1282 11.1003 19.2109 11.0306 19.2806C10.9609 19.3503 10.8782 19.4056 10.7872 19.4433C10.6961 19.481 10.5985 19.5004 10.5 19.5004C10.4014 19.5004 10.3039 19.481 10.2128 19.4433C10.1218 19.4056 10.0391 19.3503 9.96937 19.2806L3.21937 12.5306C3.14964 12.461 3.09432 12.3782 3.05658 12.2872C3.01883 12.1961 2.9994 12.0986 2.9994 12C2.9994 11.9014 3.01883 11.8038 3.05658 11.7128C3.09432 11.6217 3.14964 11.539 3.21937 11.4694L9.96937 4.71936C10.1101 4.57863 10.301 4.49957 10.5 4.49957C10.699 4.49957 10.8899 4.57863 11.0306 4.71936C11.1714 4.8601 11.2504 5.05097 11.2504 5.24999C11.2504 5.44901 11.1714 5.63988 11.0306 5.78061L5.56031 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z"
                  fill="#084A81"
                />
              </g>
              <defs>
                <clipPath id="clip0_2703_52457">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <span class="fw-bold text-decoration-none">Voltar</span>
        </a>
      </div>
      <div class="modal-body border border-2 rounded-3 p-4 bg-light">
        <h3
          *ngIf="hasClients"
          class="border-start border-4 border-primary fw-medium mt-mobile ps-2 mb-4"
        >
          Selecione um cliente para acessar o estudo
        </h3>
        <div>
          <div class="mb-4">
            <div class="input-group flex-nowrap border-2">
              <span
                class="input-group-text bg-transparent border-end-0"
                id="addon-wrapping"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21.5306 20.4694L16.8365 15.7762C18.1971 14.1428 18.8755 12.0478 18.7307 9.92694C18.5859 7.80607 17.629 5.82268 16.0591 4.38935C14.4892 2.95602 12.4271 2.18311 10.3019 2.23141C8.17663 2.27971 6.15181 3.1455 4.64864 4.64867C3.14547 6.15184 2.27968 8.17666 2.23138 10.3019C2.18308 12.4272 2.95599 14.4892 4.38932 16.0591C5.82265 17.629 7.80604 18.5859 9.92691 18.7307C12.0478 18.8755 14.1428 18.1971 15.7762 16.8366L20.4693 21.5306C20.539 21.6003 20.6218 21.6556 20.7128 21.6933C20.8038 21.731 20.9014 21.7504 21 21.7504C21.0985 21.7504 21.1961 21.731 21.2871 21.6933C21.3782 21.6556 21.4609 21.6003 21.5306 21.5306C21.6003 21.4609 21.6556 21.3782 21.6933 21.2872C21.731 21.1961 21.7504 21.0985 21.7504 21C21.7504 20.9015 21.731 20.8039 21.6933 20.7128C21.6556 20.6218 21.6003 20.5391 21.5306 20.4694ZM3.74997 10.5C3.74997 9.16498 4.14585 7.85993 4.88755 6.7499C5.62925 5.63987 6.68345 4.7747 7.91686 4.26381C9.15026 3.75292 10.5075 3.61925 11.8168 3.8797C13.1262 4.14015 14.3289 4.78302 15.2729 5.72703C16.2169 6.67103 16.8598 7.87377 17.1203 9.18314C17.3807 10.4925 17.247 11.8497 16.7362 13.0831C16.2253 14.3165 15.3601 15.3707 14.2501 16.1124C13.14 16.8541 11.835 17.25 10.5 17.25C8.71037 17.248 6.99463 16.5362 5.72919 15.2708C4.46375 14.0053 3.75195 12.2896 3.74997 10.5Z"
                    fill="#43474E"
                  />
                </svg>
              </span>
              <input
                id="input_search"
                type="text"
                class="form-control border-start-0 bg-transparent"
                placeholder="Pesquisar cliente"
                aria-label="Pesquisar cliente"
                aria-describedby="addon-wrapping"
                [(ngModel)]="search"
                (ngModelChange)="onSearchChange()"
              />
            </div>
          </div>

          <div
            *ngIf="hasClients && !isLoading"
            class="border border-2 p-2 rounded-2 responsive"
          >
            <table class="table table-responsive table-hover caption-top mb-0">
              <thead>
                <tr class="bg-transparent">
                  <th class="bg-transparent">Cliente</th>
                  <th class="bg-transparent">Última Atualização</th>
                  <th class="bg-transparent">Criação</th>
                  <th class="bg-transparent"></th>
                </tr>
              </thead>
              <tbody class="responsive">
                <tr
                  *ngFor="let item of clientsData; trackBy: trackByIndex"
                  style="cursor: pointer"
                  (click)="goToClientStudies(item._id)"
                >
                  <td class="col-6 bg-transparent">
                    <a
                      [id]="'client_name' + item._id"
                      class="text-black overflow-remove text-decoration-none"
                      >{{ item.fullName }}</a
                    >
                  </td>
                  <td class="bg-transparent">
                    {{ item.updatedAt | date : "dd/MM/yyyy HH:mm" }}
                  </td>
                  <td class="bg-transparent">
                    {{ item.createdAt | date : "dd/MM/yyyy HH:mm" }}
                  </td>
                  <td class="p-0 bg-transparent"></td>
                </tr>
              </tbody>
            </table>

            <div class="mt-2 mb-2">
              <div class="d-flex justify-content-center mt-3">
                <nav aria-label="Page navigation">
                  <ul
                    class="pagination align-items-center my-auto col-5 justify-content-center"
                  >
                    <!-- voltar -->
                    <li class="page-item" [class.disabled]="currentPage === 1">
                      <a
                        class="btn on-hover rounded-5 p-1"
                        (click)="goToPreviousPage()"
                      >
                        <svg
                          width="24"
                          height="24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 5L3 12L8 19"
                            stroke="#43474E"
                            stroke-width="2"
                          />
                        </svg>
                      </a>
                    </li>

                    <!-- páginas -->
                    <li
                      class="page-item"
                      *ngFor="let page of pagesArray"
                      [class.active]="page === currentPage"
                    >
                      <button
                        class="page-link me-2"
                        (click)="goToPage(page)"
                        [ngClass]="{
                          'fw-bold text-white bg-primary border-primary':
                            page === currentPage
                        }"
                      >
                        {{ page }}
                      </button>
                    </li>

                    <!-- avançar -->
                    <li
                      class="page-item"
                      [class.disabled]="currentPage === totalPages"
                    >
                      <a
                        class="btn on-hover rounded-5 p-1"
                        (click)="goToNextPage()"
                      >
                        <svg
                          width="24"
                          height="24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 5L21 12L16 19"
                            stroke="#43474E"
                            stroke-width="2"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <app-loading *ngIf="isLoading"></app-loading>
        </div>
        <div *ngIf="!hasClients && !isLoading">
          <div class="text-center p-5" style="height: 25rem">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              fill="#0A5DA1"
            >
              <path
                d="M43.2968 39.75C40.4412 34.8131 36.0405 31.2731 30.9049 29.595C33.4452 28.0827 35.4189 25.7784 36.5228 23.0359C37.6267 20.2933 37.7999 17.2643 37.0156 14.4138C36.2314 11.5633 34.5332 9.04912 32.1817 7.25724C29.8303 5.46536 26.9557 4.4949 23.9993 4.4949C21.0429 4.4949 18.1683 5.46536 15.8168 7.25724C13.4654 9.04912 11.7672 11.5633 10.9829 14.4138C10.1987 17.2643 10.3718 20.2933 11.4758 23.0359C12.5797 25.7784 14.5534 28.0827 17.0937 29.595C11.958 31.2713 7.55741 34.8113 4.70179 39.75C4.59707 39.9208 4.52761 40.1108 4.4975 40.3088C4.4674 40.5068 4.47727 40.7089 4.52652 40.903C4.57577 41.0972 4.66341 41.2795 4.78427 41.4393C4.90513 41.599 5.05676 41.7329 5.23021 41.8331C5.40366 41.9333 5.59542 41.9977 5.79418 42.0226C5.99293 42.0475 6.19466 42.0323 6.38745 41.9779C6.58025 41.9236 6.7602 41.8312 6.9167 41.7062C7.0732 41.5811 7.20308 41.426 7.29866 41.25C10.8312 35.145 17.0749 31.5 23.9993 31.5C30.9237 31.5 37.1674 35.145 40.6999 41.25C40.7955 41.426 40.9254 41.5811 41.0819 41.7062C41.2384 41.8312 41.4183 41.9236 41.6111 41.9779C41.8039 42.0323 42.0056 42.0475 42.2044 42.0226C42.4032 41.9977 42.5949 41.9333 42.7684 41.8331C42.9418 41.7329 43.0934 41.599 43.2143 41.4393C43.3352 41.2795 43.4228 41.0972 43.4721 40.903C43.5213 40.7089 43.5312 40.5068 43.5011 40.3088C43.471 40.1108 43.4015 39.9208 43.2968 39.75ZM13.4993 18C13.4993 15.9233 14.1151 13.8932 15.2689 12.1665C16.4226 10.4398 18.0625 9.09399 19.9811 8.29927C21.8997 7.50455 24.0109 7.29661 26.0477 7.70176C28.0845 8.1069 29.9555 9.10693 31.4239 10.5754C32.8924 12.0438 33.8924 13.9148 34.2975 15.9516C34.7027 17.9884 34.4947 20.0996 33.7 22.0182C32.9053 23.9368 31.5595 25.5767 29.8328 26.7304C28.1061 27.8842 26.076 28.5 23.9993 28.5C21.2154 28.497 18.5464 27.3898 16.578 25.4213C14.6095 23.4529 13.5023 20.7839 13.4993 18Z"
                fill="#0A5DA1"
              />
            </svg>

            <h2 class="mt-2 mb-2">Seus clientes cadastrados ficarão aqui</h2>
            <p class="mb-4">
              Acesse a techfinance para cadastrar um novo cliente.
            </p>
            <a
              id="client-study-add"
              class="btn btn-outline-primary border border-2 border-primary"
              href="https://app.techfinance.com.br"
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <g clip-path="url(#clip0_3072_30428)">
                  <path
                    d="M24.4998 12.75C24.4998 12.9489 24.4207 13.1397 24.2801 13.2803C24.1394 13.421 23.9487 13.5 23.7498 13.5H22.2498V15C22.2498 15.1989 22.1707 15.3897 22.0301 15.5303C21.8894 15.671 21.6987 15.75 21.4998 15.75C21.3008 15.75 21.1101 15.671 20.9694 15.5303C20.8288 15.3897 20.7498 15.1989 20.7498 15V13.5H19.2498C19.0508 13.5 18.8601 13.421 18.7194 13.2803C18.5788 13.1397 18.4998 12.9489 18.4998 12.75C18.4998 12.5511 18.5788 12.3603 18.7194 12.2197C18.8601 12.079 19.0508 12 19.2498 12H20.7498V10.5C20.7498 10.3011 20.8288 10.1103 20.9694 9.96967C21.1101 9.82901 21.3008 9.75 21.4998 9.75C21.6987 9.75 21.8894 9.82901 22.0301 9.96967C22.1707 10.1103 22.2498 10.3011 22.2498 10.5V12H23.7498C23.9487 12 24.1394 12.079 24.2801 12.2197C24.4207 12.3603 24.4998 12.5511 24.4998 12.75ZM19.0744 18.2672C19.2025 18.4196 19.2648 18.6166 19.2475 18.815C19.2303 19.0133 19.135 19.1966 18.9826 19.3247C18.8302 19.4527 18.6331 19.515 18.4348 19.4978C18.2365 19.4805 18.0531 19.3852 17.9251 19.2328C16.0388 16.9866 13.4457 15.75 10.6248 15.75C7.80382 15.75 5.21069 16.9866 3.32444 19.2328C3.19639 19.3851 3.01309 19.4803 2.81486 19.4974C2.61663 19.5146 2.41971 19.4523 2.26741 19.3242C2.11512 19.1962 2.01993 19.0129 2.00279 18.8146C1.98565 18.6164 2.04796 18.4195 2.17601 18.2672C3.57663 16.6003 5.31851 15.4162 7.25444 14.7825C6.07873 14.0502 5.17349 12.9549 4.67569 11.6624C4.17789 10.3698 4.11461 8.95028 4.49543 7.61855C4.87624 6.28681 5.68043 5.11534 6.78632 4.28135C7.89222 3.44736 9.23964 2.99625 10.6248 2.99625C12.0099 2.99625 13.3573 3.44736 14.4632 4.28135C15.5691 5.11534 16.3733 6.28681 16.7541 7.61855C17.1349 8.95028 17.0716 10.3698 16.5738 11.6624C16.076 12.9549 15.1708 14.0502 13.9951 14.7825C15.931 15.4162 17.6729 16.6003 19.0744 18.2672ZM10.6248 14.25C11.5889 14.25 12.5315 13.9641 13.3332 13.4284C14.1349 12.8927 14.7597 12.1314 15.1287 11.2406C15.4976 10.3498 15.5942 9.36959 15.4061 8.42393C15.218 7.47827 14.7537 6.60963 14.0719 5.92785C13.3901 5.24607 12.5215 4.78177 11.5758 4.59367C10.6302 4.40556 9.64996 4.50211 8.75917 4.87108C7.86838 5.24006 7.10701 5.8649 6.57134 6.66659C6.03567 7.46828 5.74976 8.41081 5.74976 9.375C5.75124 10.6675 6.26534 11.9066 7.17925 12.8205C8.09317 13.7344 9.33228 14.2485 10.6248 14.25Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3072_30428">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="fw-semibold ms-2">Acessar Techfinance</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
